export default "__VITE_ASSET__DTYgYinE__"